













































































import {Component, Vue} from "vue-property-decorator";
import {namespace, Action} from "vuex-class";

import {DroppoErrors} from '@/constants/errors';
import ShipmentForm from '@/views/components/ShipmentForm.vue';
import {IActiveShipment, IHub} from '@/models/StoreModels';
import {IPhoneNumber} from '@/models/IPhoneNumber';
import {cellSizesTranslatedStrings, ORDER_PROCESS_DROPUP_PAGE} from '@/constants/orders';
import {errorHandler} from "@/services/services";
import {IApiErrors, IUserData} from "@/models/ApiModels";
import {isErrorType} from "@/services/errorHandling";
import {CLICK_AND_COLLECT_ROUTES, CROSS_TOWN_ROUTES} from "@/constants/routes";

const shipmentStore = namespace("shipment");
const hubsStore = namespace("hubs");
const userDataStore = namespace("userData");

@Component({
  name: 'Summary',
  components: {
    ShipmentForm,
  },
})
export default class Summary extends Vue {
  @Action('sendCCToApi')
  private sendClickAndCollectEmail!: () => Promise<any>;

  @userDataStore.Getter('getProfile')
  private profile!: IUserData;

  @shipmentStore.Getter('getCCPhoneNumber')
  private ccPhoneNumber!: string;

  @shipmentStore.Getter('getCCName')
  private ccName!: string;

  @shipmentStore.Getter('getCCShopAddress')
  private ccShopAddress!: string;

  @shipmentStore.Getter('getCCSComments')
  private ccComments!: string;

  @shipmentStore.Getter('getCCHub')
  private ccHub!: IHub;

  @Action('createCrosstownShipment')
  private createCrosstownShipment!: () => Promise<IActiveShipment>;

  private errors: IApiErrors = {};

  private next() {
    this.clearErrors();
    this.$router.push({name: CLICK_AND_COLLECT_ROUTES.SUMMARY});

    this.$uiBus.emit("apiStatus:loading");
    this.sendClickAndCollectEmail()
        .then(this.goToFinish)
        .then(() => this.$uiBus.emit("apiStatus:error"))
        .catch((err) => this.showErrors(err))
        .finally(() => this.$uiBus.emit("apiStatus:finish"));
  }


  private goToFinish() {
    this.$router.push({ name: CLICK_AND_COLLECT_ROUTES.FINISH });
  }

  private showErrors(err: any) {
    if (isErrorType(DroppoErrors.NO_CELL_ERROR, err)) {
      this.$uiBus.emit('crossTown:goToSelectCellSize');
    }
    this.$uiBus.emit("apiStatus:error");
    const errors = errorHandler.handleErrorsResponse(err, 'deliverySummary.errors');
    Vue.set(this, 'errors', errors);
  }

  private clearErrors() {
    Vue.set(this, 'errors', {});
  }

  private goToForm() {
    this.clearErrors();
    this.$router.push({
      name: CLICK_AND_COLLECT_ROUTES.FORM,
    });
  }

}
